// extracted by mini-css-extract-plugin
export default {"totalResult":"Pagination_totalResult__Prv73","totalResultItem":"Pagination_totalResultItem__CZ0Gb"};